import { render, staticRenderFns } from "./Cleanup.vue?vue&type=template&id=7828d3be&"
import script from "./Cleanup.vue?vue&type=script&lang=js&"
export * from "./Cleanup.vue?vue&type=script&lang=js&"
import style0 from "./Cleanup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports